import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { useIntercomLifecycle } from "hooks/useIntercom";

const LEGACY_SUPPORT_TRIGGER_SELECTOR =
  ".support-tour, .contactSupport, .support-chat";

const SELECT_CHANNEL_ROUTE_PATTERN = /^\/auth\/select-channel\//;

const IntercomManager = () => {
  const location = useLocation();
  const { logged_in, user } = useSelector((state) => ({
    logged_in: state.logged_in,
    user: state.user,
  }));

  const { pathname } = location;
  const isAuthenticatedAppRoute =
    pathname.startsWith("/dashboard") || pathname.startsWith("/onboarding");
  const isSelectChannelRoute = SELECT_CHANNEL_ROUTE_PATTERN.test(pathname);

  useIntercomLifecycle({
    user: logged_in ? user : undefined,
    customLauncherSelector: isAuthenticatedAppRoute
      ? LEGACY_SUPPORT_TRIGGER_SELECTOR
      : undefined,
    hideDefaultLauncher: isAuthenticatedAppRoute,
    enabled: !isSelectChannelRoute,
  });

  return null;
};

export default IntercomManager;
